import { memo } from 'react';

import CradlLogoSVG from '@/assets/cradl-logo.svg?react';
import { merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';

export type CradlLogoProps = LogoProps;

const ICradlLogo = ({ className, size, ...rest }: CradlLogoProps) => {
  return (
    <Logo
      className={merge(
        'flex items-center justify-center rounded-lg border border-gray-200 bg-linear-to-b from-white to-gray-100',
        className
      )}
      size={size}
      {...rest}
    >
      <CradlLogoSVG />
    </Logo>
  );
};

export const CradlLogo = memo(ICradlLogo) as typeof ICradlLogo;
